import { Location } from '@angular/common';
import { Component, OnInit, ViewChild, EventEmitter, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EmailGenerationFormComponent } from '../email-generation-form/email-generation-form.component';
import { QuotesService } from 'src/app/quotes/quotes.service';
import { ToastrService } from 'ngx-toastr';
import * as _ from 'lodash';
import { CommonService } from 'src/app-core/services/common.service';
import { DocumentTypeIdsEnum } from '../app-common-enum';
import { OrdersDocumentsListComponent } from '../orders-documents-list/orders-documents-list.component';
import { NgForm } from '@angular/forms';
import { finalize } from 'rxjs/operators';
import { CommonDataModel } from '../common-data-model';
import { CommonConstants } from 'src/app-core/constants/common-constants';

@Component({
    selector: 'app-orders-admin-requests',
    templateUrl: './orders-admin-requests.component.html',
    styleUrls: ['./orders-admin-requests.component.scss']
})
export class OrdersAdminRequestsComponent implements OnInit {
    @Output() activate: EventEmitter<any> = new EventEmitter<any>();
    @ViewChild('requestPriceForm', { static: false }) requestPriceForm: NgForm;
    @ViewChild('notificationArrivalForm', { static: false }) notificationArrivalForm: NgForm;
    @ViewChild('requestForPrice', { static: false }) requestForPrice: EmailGenerationFormComponent;
    @ViewChild('notificationOfArrival', { static: false }) notificationOfArrival: EmailGenerationFormComponent;

    @ViewChild('reqForPriceDocs', { static: false }) reqForPriceDocs: OrdersDocumentsListComponent;
    @ViewChild('notificationArrivalDocs', { static: false }) notificationArrivalDocs: OrdersDocumentsListComponent;

    commonDataModel = new CommonDataModel();
    requestForPriceForm = this.commonDataModel.requestForPriceFormModel;
    quotesPermission = this.commonDataModel.quotesPermissionModel;
    quickQuotePermission = this.commonDataModel.quickQuotesPermissionModel;
    jobsPermission = this.commonDataModel.jobsPermissionModel;
    notificationOfArrivalForm = this.commonDataModel.notificationOfArrivalFormModel;
    documentTypeEnum: typeof DocumentTypeIdsEnum = DocumentTypeIdsEnum;
    orderId: any;
    orderDetails: any;
    isQuickQuote = false;
    documentConfigs: any;
    isFormLoading = false;
    selectedDocumentTypeId = 9;
    tenantList = [];
    tenantListFiltered: any;
    documentConfigsTemp: any;
    isJob: any;
    isViewRequestToPrice = false;
    isViewNotificationOfArrival = false;
    statusUpdateModel = this.commonDataModel.ordersBulkStatusUpdateModel;
    statusList = [];

    constructor(
        private location: Location,
        private activatedRoute: ActivatedRoute,
        private quotesService: QuotesService,
        private toastr: ToastrService,
        private commonService: CommonService
    ) {
        this.quotesPermission = this.commonService.permissionChecker(this.quotesPermission);
        this.quickQuotePermission = this.commonService.permissionChecker(this.quickQuotePermission);
        this.jobsPermission = this.commonService.permissionChecker(this.jobsPermission);
    }

    ngOnInit() {
        if (this.activatedRoute.snapshot.queryParams.quoteId) {
            this.orderId = this.activatedRoute.snapshot.queryParams.quoteId;
        } else {
            this.orderId = this.activatedRoute.snapshot.queryParams.jobId;
        }
        this.getTenantList();
        this.getDocumentConfigs();
        this.onGetOrderDetailsAccount();
    }

    getOrderStatus() {
        let queryString = `IsJob=${this.orderDetails.isJob ? true : false}`;
        if (this.orderId) {
            queryString += `&OrderId=${this.orderDetails.id}`;
        }
        this.commonService.getOrderStatus(queryString).subscribe((response: any) => {
            this.statusList = response.data;
        });
    }

    getTenantList(): void {
        this.commonService.getTenants().subscribe(response => {
            if (response.isSuccess) {
                this.tenantList = response.data;
                this.tenantListFiltered = response.data;
            }
        });
    }

    onHandleFilter(value: any) {
        this.tenantList = this.tenantListFiltered.filter((s) =>
            s.name.toLowerCase().includes(value.toLowerCase()) ||
            s.code.toLowerCase().includes(value.toLowerCase())
        );
    }

    onGetOrderDetailsAccount(): void {
        this.quotesService.getQuote(this.orderId).subscribe(response => {
            if (response.isSuccess) {
                this.orderDetails = response.data;
                this.isQuickQuote = response.data.isQuickQuote;
                this.isJob = this.orderDetails.isJob;
                if (this.isJob) {
                    if (this.jobsPermission.JobsDocumentsAdminRequestRequestForPrice) {
                        this.isViewRequestToPrice = true;
                    }
                    if (this.jobsPermission.JobsDocumentsAdminRequestNotificationOfArrival) {
                        this.isViewNotificationOfArrival = true;
                    }
                } else if (!this.isQuickQuote) {
                    if (this.quotesPermission.QuotesDocumentsAdminRequestRequestForPrice) {
                        this.isViewRequestToPrice = true;
                    }
                    if (this.quotesPermission.QuotesDocumentsAdminRequestNotificationOfArrival) {
                        this.isViewNotificationOfArrival = true;
                    }
                } else {
                    this.isViewRequestToPrice = true;
                    this.isViewNotificationOfArrival = true;
                }
                this.getOrderStatus();
            }
        });
    }

    onDocumentTabChange(event: any) {
        switch (event.tab.textLabel) {
            case 'Request For Price':
                this.selectedDocumentTypeId = this.documentTypeEnum.requestForPrice;
                break;
            case 'Notification Of Arrival':
                this.selectedDocumentTypeId = this.documentTypeEnum.notificationOfArrival;
                break;
            default:
                this.selectedDocumentTypeId = null;
                break;
        }
        this.getDocumentConfigs();
    }

    getDocumentConfigs() {
        this.quotesService.getDocumentConfig(this.orderId, this.selectedDocumentTypeId).subscribe(response => {
            if (response.isSuccess) {
                this.documentConfigs = response.data;
                this.documentConfigsTemp = _.cloneDeep(response.data);
            }
        });
    }

    onRequestForPrice(): void {
        this.onRequestForPriceContinue();
    }

    onRequestForPriceContinue() {
        this.requestForPriceForm.orderId = this.orderId;
        this.requestForPriceForm.emailDetails = this.requestForPrice.emailForm;
        const requestForPriceForm = _.cloneDeep(this.requestForPriceForm);
        if (requestForPriceForm.isSendEmail) {
            if (!this.requestForPrice.isEmailtoValid()) {
                return this.toEmailValidationMessage();
            }
            if (!this.requestForPrice.isEmailccValid()) {
                return this.ccEmailValidationMessage();
            }
            if (!this.requestForPrice.isEmailbccValid()) {
                return this.bccEmailValidationMessage();
            }
        }
        this.setAdditionalEmails(requestForPriceForm.emailDetails, this.requestForPrice);
        delete requestForPriceForm.emailDetails.bccToMyself;
        delete requestForPriceForm.isview;
        this.isFormLoading = true;
        this.commonService.requestForPriceDocument(requestForPriceForm)
            .pipe(finalize(() => (this.isFormLoading = false)))
            .subscribe(response => {
                this.isFormLoading = false;
                if (response.isSuccess) {
                    this.toastr.success(response.errors);
                    this.reqForPriceDocs.onRefreshGridData();
                } else {
                    this.toastr.error(response.errors || CommonConstants.appComponent.somethingWenWrongPleaseReTry, CommonConstants.appComponent.error);
                }
            });
    }

    toEmailValidationMessage() {
        this.toastr.warning(CommonConstants.appComponent.toEmailValidationMessage);
    }

    ccEmailValidationMessage() {
        this.toastr.warning(CommonConstants.appComponent.ccEmailValidationMessage);
    }

    bccEmailValidationMessage() {
        this.toastr.warning(CommonConstants.appComponent.bccEmailValidationMessage);
    }

    setAdditionalEmails(addIn, addFrom) {
        // additional for To email
        if (addFrom.toFromContact && addFrom.documentConfigData.shipFromEmail) {
            addIn.to += (addIn.to) ? `;${addFrom.documentConfigData.shipFromEmail}` : addFrom.documentConfigData.shipFromEmail;
        }
        if (addFrom.toToContact && addFrom.documentConfigData.shipToEmail) {
            addIn.to += (addIn.to) ? `;${addFrom.documentConfigData.shipToEmail}` : addFrom.documentConfigData.shipToEmail;
        }
        if (addFrom.toPayerContact && addFrom.documentConfigData.payerEmail) {
            addIn.to += (addIn.to) ? `;${addFrom.documentConfigData.payerEmail}` : addFrom.documentConfigData.payerEmail;
        }
        if (addFrom.toIntermediaryContact && addFrom.documentConfigData.intermediateEmail) {
            addIn.to += (addIn.to) ? `;${addFrom.documentConfigData.intermediateEmail}` : addFrom.documentConfigData.intermediateEmail;
        }
        // additional for Cc email
        if (addFrom.ccFromContact && addFrom.documentConfigData.shipFromEmail) {
            addIn.cc += (addIn.cc) ? `;${addFrom.documentConfigData.shipFromEmail}` : addFrom.documentConfigData.shipFromEmail;
        }
        if (addFrom.ccToContact && addFrom.documentConfigData.shipToEmail) {
            addIn.cc += (addIn.cc) ? `;${addFrom.documentConfigData.shipToEmail}` : addFrom.documentConfigData.shipToEmail;
        }
        if (addFrom.ccPayerContact && addFrom.documentConfigData.payerEmail) {
            addIn.cc += (addIn.cc) ? `;${addFrom.documentConfigData.payerEmail}` : addFrom.documentConfigData.payerEmail;
        }
        if (addFrom.ccIntermediaryContact && addFrom.documentConfigData.intermediateEmail) {
            addIn.cc += (addIn.cc) ? `;${addFrom.documentConfigData.intermediateEmail}` : addFrom.documentConfigData.intermediateEmail;
        }
        // additional for Bcc email
        if (addFrom.emailForm.bccToMyself && addFrom.documentConfigData.meEmail) {
            addIn.bcc += (addIn.bcc) ? `;${addFrom.documentConfigData.meEmail}` : addFrom.documentConfigData.meEmail;
        }
    }

    onNotificationOfArrival(): void {
        this.onNotificationOfArrivalContinue();
    }

    onNotificationOfArrivalContinue() {
        this.notificationOfArrivalForm.orderId = this.orderId;
        this.notificationOfArrivalForm.emailDetails = this.notificationOfArrival.emailForm;
        const notificationOfArrivalForm = _.cloneDeep(this.notificationOfArrivalForm);
        if (notificationOfArrivalForm.isSendEmail) {
            if (!this.notificationOfArrival.isEmailtoValid()) {
                return this.toEmailValidationMessage();
            }
            if (!this.notificationOfArrival.isEmailccValid()) {
                return this.ccEmailValidationMessage();
            }
            if (!this.notificationOfArrival.isEmailbccValid()) {
                return this.bccEmailValidationMessage();
            }
        }
        this.setAdditionalEmails(notificationOfArrivalForm.emailDetails, this.notificationOfArrival);
        delete notificationOfArrivalForm.emailDetails.bccToMyself;
        delete notificationOfArrivalForm.isview;
        this.isFormLoading = true;
        this.commonService.notificationOfArrivalDocument(notificationOfArrivalForm)
            .pipe(finalize(() => (this.isFormLoading = false))).subscribe(response => {
                this.isFormLoading = false;
                if (response.isSuccess) {
                    this.toastr.success(response.errors);
                    this.notificationArrivalDocs.onRefreshGridData();
                } else {
                    this.toastr.error(response.errors || CommonConstants.appComponent.somethingWenWrongPleaseReTry, CommonConstants.appComponent.error);
                }
            });
    }

    onFranchiseChange(event: any) {
        if (event.id) {
            this.documentConfigs.shipToEmail = event.email;
        } else {
            this.documentConfigs.shipToEmail = this.documentConfigsTemp.shipToEmail;
        }
    }

    onResetRequestForPriceForm() {
        this.requestPriceForm.reset();
        this.requestForPrice.resetForm();
    }

    onResetNotificationOfArrivalForm() {
        this.notificationArrivalForm.reset();
        this.notificationOfArrival.resetForm();
    }

    onGoBack(): void {
        this.location.back();
    }

}
